import { type Ref, ref, watch } from 'vue'

function getCookie(name: string): string | null {
  if (typeof document === 'undefined') {
    return null
  }
  const cookies = document.cookie.split('; ')
  const cookie = cookies.find((row) => row.startsWith(`${name}=`))
  return cookie ? cookie.split('=')[1] : null
}

function setCookie(name: string, value: string) {
  if (typeof document === 'undefined') {
    return
  }
  const expires = new Date()
  expires.setFullYear(expires.getFullYear() + 1)
  document.cookie = `${name}=${value}; path=/; expires=${expires.toUTCString()}`
}

export function useCookie(name: string): Ref<string | null> {
  const cookie = ref<string | null>(getCookie(name))

  watch(cookie, (newValue) => {
    if (newValue !== null) {
      setCookie(name, newValue)
    }
  })

  return cookie
}
